import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthenticatedAxios } from '../useAuthenticatedAxios';
import { toast } from '../../../components/Toast';
import { workRegisterKeys } from './workRegisters.key';

type Options = {
  onDeletePersonnelSuccess?: () => void;
  onDeletePersonnelError?: (error: unknown) => void;
};

export function useDeletePersonnel(controlId: string, options?: Options) {
  const getAxios = useAuthenticatedAxios();
  const queryClient = useQueryClient();

  const deletePersonnel = async (personnelId: string) => {
    const axios = await getAxios();
    await axios.delete(`/api/v1/personnel/${personnelId}`);
  };

  const onSuccess = () => {
    toast.success('Personen har raderats');
    queryClient.invalidateQueries({
      queryKey: workRegisterKeys.personnelAll(controlId),
    });
    options?.onDeletePersonnelSuccess?.();
  };

  const onError = (error: unknown) => {
    toast.error('Kunde inte radera personen');
    options?.onDeletePersonnelError?.(error);
  };

  return useMutation(deletePersonnel, {
    onSuccess,
    onError,
  });
}
